import axios from "axios";
import { useEffect, useState } from "react";
import DailyWeatherItem from "./dailyweatherItem/DailyweatherItem";
import TodayWeather from "./TodayWeather/TodayWeather";
import "./mainComponent.css";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  getWidgetCredentialsQuery,
  getWeatherData,
} from "@src/graphQl/querys/widgetsQuerys.js";

const Weather = ({ id, t }) => {
  const dispatch = useDispatch();
  const [todaywetherData, setTodaysetWeatherData] = useState([
    { main: { temp: "" }, weather: [{ icon: "", main: "" }] },
    { main: { temp: "" }, weather: [{ icon: "", main: "" }] },
    { main: { temp: "" }, weather: [{ icon: "", main: "" }] },
    { main: { temp: "" }, weather: [{ icon: "", main: "" }] },
  ]);
  const [Geolocation, setGeolocation] = useState({});
  const [daylyWeather, setDailyWeather] = useState([]);
  const [city, setCity] = useState({});
  const [api, setEndpoint] = useState(
    process.env.REACT_APP_WEATHER_API_ENDPOINT
  );

  const API = process.env.REACT_APP_QUIZZ_ENDPOINT;
  const ENDPOINT = process.env.REACT_APP_QUERY_ENDPOINY;

  const fetchdata = async (Geo, creed) => {
    var locationData =
      Geo.latitude !== undefined
        ? `lat=${Geo.latitude}&lon=${Geo.longitude}`
        : "q=El Aouina";
    const endpoint = `${creed.endPoint}/2.5/forecast?${locationData}&appid=${creed.Token}&units=metric`;
    //    axios.get(endpoint)
    //    .then(({data})=>{
    //      setDailyWeather(()=>data.list.filter(ele => ele.dt_txt.includes('15:00:00')))
    //      const TodayDate= getTodaysdate()
    //      setCity(()=>data.city)
    //  //    setTodaysetWeatherData(()=>data.list.filter(ele => ele.dt_txt.split(" ")[0]===TodayDate.split(" ")[0]))

    //     }).catch((err)=>{
    //     })
  };

  const getWidgetCredentials = () => {
    axios
      .post(
        `${process.env.REACT_APP_QUIZZ_ENDPOINT}/${process.env.REACT_APP_QUERY_ENDPOINY}`,
        { query: getWidgetCredentialsQuery(id) }
      )
      .then((res) => {
        navigator.geolocation.getCurrentPosition((position) => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          //setGeolocation(()=>({latitude,longitude}))
          fetchdata({ latitude, longitude }, res.data.data.getCredentials);
          axios
            .post(`${API}/${ENDPOINT}/query`, {
              query: getWeatherData("Tunis"),
            })
            .then((res) => {
              const weatherDataJSON = res.data?.data?.widgetDatum?.API_data;
              const weatherDate = JSON.parse(weatherDataJSON);
              const TodayDate = getTodaysdate();
              setTodaysetWeatherData(() =>
                weatherDate?.list?.filter(
                  (ele) => ele.dt_txt.split(" ")[0] === TodayDate.split(" ")[0]
                )
              );
              setDailyWeather(() =>
                weatherDate?.list.filter((ele) =>
                  ele.dt_txt.includes("15:00:00")
                )
              );
            });
        });
      });
  };

  const getTodaysdate = () => {
    var today = new Date();
    const day = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
    const month =
      today.getMonth() + 1 < 10
        ? "0" + (today.getMonth() + 1)
        : today.getMonth() + 1;
    var date = today.getFullYear() + "-" + month + "-" + day;

    var time = today.getHours() + ":" + today.getMinutes() + ":00";
    var dateTime = date + " " + time;
    return dateTime;
  };

  useEffect(() => {
    getWidgetCredentials();
  }, []);

  return (
    <div className="mainContainer">
      <div className="headerContainer">
        <TodayWeather
          t={t}
          weatherInThisTime={todaywetherData}
          weatherLocation={city}
        />
      </div>

      <div className="dailyWeatherContainer">
        {daylyWeather?.map((ele, i) => (
          <DailyWeatherItem t={t} key={i} itemData={ele} />
        ))}
      </div>
    </div>
  );
};

export default Weather;
